<template>
  <div class="table-responsive">
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Item</th>
          <th>Cantidad</th>
          <th>
            <button 
              @click="agregar" 
              class="btn-success" 
              type="button"
            >
              <i class="fa fa-plus"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          @eliminar="eliminar"
          v-for="(item, index) in modelValue"
          v-model="modelValue[index]"
          :index="index"
          :key="moment(new Date()).format('YYYYMMDDHHmmss') + index"
          is="tr-egreso-bodega"
        >
        </tr>      
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: false,
      default: function () {
        return [];
      }
    }
  },
  data: function() {
    return {
      modelValue: this.value,
      moment: moment,
    }
  },
  methods: {
    agregar: function () {
      this.modelValue.push({
        item_id: null,
        nombre: '',
        cantidad: 1
      });
    },
    eliminar: function(index) {
      this.modelValue.splice(index, 1);
    },
  },
  mounted: function() {
    
  }
}

</script><template>
  <div class="table-responsive">
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Item</th>
          <th>Cantidad</th>
          <th>
            <button 
              @click="agregar" 
              class="btn-success" 
              type="button"
            >
              <i class="fa fa-plus"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          @eliminar="eliminar"
          v-for="(item, index) in modelValue"
          v-model="modelValue[index]"
          :index="index"
          :key="moment(new Date()).format('YYYYMMDDHHmmss') + index"
          is="tr-egreso-bodega"
        >
        </tr>      
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: false,
      default: function () {
        return [];
      }
    }
  },
  data: function() {
    return {
      modelValue: this.value,
      moment: moment,
    }
  },
  methods: {
    agregar: function () {
      this.modelValue.push({
        item_id: null,
        nombre: '',
        cantidad: 1
      });
    },
    eliminar: function(index) {
      this.modelValue.splice(index, 1);
    },
  },
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/inventario/TablaEgresoBodega.vue